import { activeConditionsQuery } from '../planner/context';
import type { ProtocolSpec } from '../planner/plan';
import { ckdOngoingMeasurements } from './ckdOngoingMeasurements';

/**
 * The chronic kidney disease ongoing-measurement protocol, ready for `planProtocol`. No variables:
 * every action is unconditional, so nothing needs deriving — but `activeConditionsQuery` is still
 * listed, because topic matching reads the patient's Conditions to find the topic this protocol
 * belongs on.
 */
export const ckdOngoingMeasurementsProtocol: ProtocolSpec = {
  planDefinition: ckdOngoingMeasurements,
  valueSets: [],
  queries: [activeConditionsQuery],
  deriveVariables: () => ({}),
};
